import { createSlice } from "@reduxjs/toolkit";
import { CategoryResponseDto } from "../../shared/dtos/category/CategoryResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const categorySlice = createSlice({
  name: "category",
  initialState: getInitialCrudState<CategoryResponseDto>(),
  reducers: { ...generateCrudReducers<CategoryResponseDto>() },
});

export const categoryActions = categorySlice.actions;
export default categorySlice.reducer;
